import styled from 'styled-components';
import { BasicProps, BasicPropTypes, shouldForwardBasicProp } from './props';

export const Col = styled.div.withConfig({
	shouldForwardProp: shouldForwardBasicProp,
})`
	display: flex;
	flex-direction: column;

	${BasicProps};
`;

Col.propTypes = {
	...BasicPropTypes,
};
